const state = () => ({
  isValid: false,
  privacyPolicyAgreement: false
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  personalDataAgreement(state) {
    return state.privacyPolicyAgreement;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updatePrivacyPolicyAgreement(state, results) {
    state.privacyPolicyAgreement = results;
  }
};

const actions = {
  updatePrivacyPolicyAgreement({ commit }, payload) {
    commit('updatePrivacyPolicyAgreement', payload);
  }
};

export const forCompaniesPrivacyPolicyAgreement = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
